<!--
<template>
  <div class="relative">
    <nav
      :class="[
        'z-50 transition-all duration-400 ease-in-out',

        // 滚动跟随条件独立控制
        shouldAlwaysFix ? 'relative' : 'fixed top-0 left-0 right-0',
        // 背景颜色条件独立控制，滚动时isScrolled变为白色，未滚动时渐变
        shouldAlwaysWhite || isScrolled
          ? 'bg-white shadow-md'
          : 'bg-gradient-to-b from-neutral-400/50 to-neutral-400/0',
      ]"
      class="w-full h-[13.33vw] flex justify-center"
    >
      &lt;!&ndash; **Logo 左上角** &ndash;&gt;
      <img
        src="@/assets/images/Header/logo.png"
        alt="蓝悦logo"
        class="absolute w-[38.13vw] h-auto left-[3.47vw] top-1/2 -translate-y-1/2"
      />

      &lt;!&ndash; 内容菜单右上角 &ndash;&gt;
      <div
        class="absolute size-[5.87vw] right-[3.47vw] top-1/2 -translate-y-1/2 justify-between"
      >
        <div
          class="h-full flex flex-col justify-between px-[0.3vw] py-[0.8vw]"
          @click="drawer = true"
          type="primary"
        >
          <div class="menu-line"></div>
          <div class="menu-line"></div>
          <div class="menu-line"></div>
        </div>
      </div>
    </nav>

    &lt;!&ndash; 菜单抽屉组件 &ndash;&gt;
    <el-drawer
      title=""
      :visible.sync="drawer"
      :with-header="true"
      :direction="direction"
      size="100%"
    >
      <el-menu>
        <el-menu-item
          @click="handleMenuItemClick('/')"
          :style="{ color: $route.path === '/' ? '#05358C' : '' }"
          class="flex justify-between items-center"
        >
          <p>首页</p>
          <i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>
        </el-menu-item>
        <el-menu-item
          @click="handleMenuItemClick('/AboutUs')"
          :style="{ color: $route.path === '/AboutUs' ? '#05358C' : '' }"
          class="flex justify-between items-center"
        >
          <p>关于我们</p>
          <i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>
        </el-menu-item>
        <el-menu-item
          @click="handleMenuItemClick('/CourseSystem')"
          :style="{ color: $route.path === '/CourseSystem' ? '#05358C' : '' }"
          class="flex justify-between items-center"
        >
          <p>课程体系</p>
          <i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>
        </el-menu-item>
        <el-menu-item
          @click="handleMenuItemClick('/Competition')"
          :style="{ color: $route.path === '/Competition' ? '#05358C' : '' }"
          class="flex justify-between items-center"
        >
          <p>白名单赛事</p>
          <i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>
        </el-menu-item>
        <el-menu-item
          @click="handleMenuItemClick('/JoinUs')"
          :style="{ color: $route.path === '/JoinUs' ? '#05358C' : '' }"
          class="flex justify-between items-center"
        >
          <p>全国加盟</p>
          <i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>
        </el-menu-item>
        <el-menu-item
          @click="handleMenuItemClick('/News')"
          :style="{ color: $route.path === '/News' ? '#05358C' : '' }"
          class="flex justify-between items-center"
        >
          <p>新闻中心</p>
          <i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>
        </el-menu-item>
        <el-menu-item
          @click="handleMenuItemClick('/ContactUs')"
          :style="{ color: $route.path === '/ContactUs' ? '#05358C' : '' }"
          class="flex justify-between items-center"
        >
          <p>联系我们</p>
          <i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>
        </el-menu-item>
      </el-menu>
    </el-drawer>
    &lt;!&ndash; 添加占位元素，当固定定位时保持布局空间 &ndash;&gt;
    <div v-if="shouldAlwaysWhite" class="h-[13.33vw] w-full"></div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "mobile_HeaderBar",
  props: {
    shouldAlwaysWhite: { type: Boolean, default: true },
    shouldAlwaysFix: { type: Boolean, default: false },
  },
  data() {
    return {
      drawer: false,
      direction: "rtl",
    };
  },
  methods: {
    // 处理菜单项点击事件
    handleMenuItemClick(path) {
      // 关闭抽屉菜单
      this.drawer = false;

      // 如果路由重复导航，则刷新页面
      if (this.$route.path === path) {
        this.$router.go(0);
      }
      // 否则进行路由跳转
      else {
        this.$router.push(path).catch(() => {
          // 跳转失败时跳转到404页面
          this.$router.push("/404");
        });
      }
    },
  },
  setup() {
    const isScrolled = ref(false);
    const drawer = ref(false);
    const direction = ref("rtl");

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 0;
    };
    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });
    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    return { isScrolled, drawer, direction };
  },
};
</script>

<style scoped>
.menu-line {
  width: 100%;
  height: 0;
  background-color: currentColor;
  outline: 0.2vw solid #000000;
  outline-offset: -0.1vw;
  transition: transform 0.3s ease;
}

/* 抽屉标题栏自定义样式 */
::v-deep .el-drawer__header {
  width: 100%; /* 宽度占满 */
  height: 13.33vw; /* 高度 */
  color: #000000; /* 文字颜色 */
  padding: 3.47vw; /* 调整内边距 */
  margin: 0;
}

/* 修改关闭按钮样式 */
::v-deep .el-drawer__close-btn {
  font-size: 6vw; /* 调整关闭图标大小 */
  color: #000000;
}

/* 抽屉内容区自定义样式 */
::v-deep .el-drawer__body {
  width: 100%; /* 宽度占满 */
  padding: 0 3.47vw 0 3.47vw; /* 调整内边距 */
}

/* 菜单容器 */
::v-deep .el-menu {
  margin-right: 0 !important; /* 清除右侧外边距 */
  padding-right: 0 !important; /* 清除右侧内边距 */
  border-right: none !important; /* 清除右侧边框 */
}

/* 菜单项 */
::v-deep .el-menu-item {
  height: 14vw;
  font-size: 4.26vw;
  font-family: "HarmonyOS Sans SC";
  color: #1a2233;
  font-weight: normal;
  border-top: 0.1vw solid #f0f0f0; /* 底部边框 */
  border-bottom: 0.1vw solid #f0f0f0; /* 底部边框 */
  padding: 0 4.26vw; /* 左右外边距 */
}

/* 新增点击样式 */
::v-deep .el-menu-item:active,
::v-deep .el-menu-item.active-item {
  background-color: #f5f5f5 !important;
  color: #999999 !important;
}
</style>-->
<template>
    <div class="relative">
        <nav
                :class="[
        'z-50 transition-all duration-400 ease-in-out',
        shouldAlwaysFix ? 'relative' : 'fixed top-0 left-0 right-0',
        (shouldAlwaysWhite || isScrolled)
          ? 'bg-white shadow-md'
          : 'bg-gradient-to-b from-neutral-400/50 to-neutral-400/0'
      ]"
                class="w-full h-[13.33vw] flex justify-center"
        >
            <!-- Logo -->
            <img
                    src="@/assets/images/Header/logo.png"
                    alt="蓝悦logo"
                    class="absolute w-[38.13vw] h-auto left-[3.47vw] top-1/2 -translate-y-1/2"
            />

            <!-- 菜单按钮 -->
            <div
                    class="absolute size-[5.87vw] right-[3.47vw] top-1/2 -translate-y-1/2 justify-between"
            >
                <div
                        class="h-full flex flex-col justify-between px-[0.3vw] py-[0.8vw]"
                        @click="drawer = true"
                        type="primary"
                >
                    <div class="menu-line"></div>
                    <div class="menu-line"></div>
                    <div class="menu-line"></div>
                </div>
            </div>
        </nav>

        <!-- 抽屉菜单 -->
        <el-drawer
                title=""
                :visible.sync="drawer"
                :with-header="true"
                :direction="direction"
                size="100%"
        >
            <el-menu>
                <el-menu-item
                        v-for="(item, index) in menuItems"
                        :key="index"
                        @click="handleMenuItemClick(item.path)"
                        :style="{ color: $route.path === item.path ? '#05358C' : '' }"
                        class="flex justify-between items-center"
                >
                    <p>{{ item.label }}</p>
                    <i class="el-icon-arrow-right el-icon--right"></i>
                </el-menu-item>
            </el-menu>
        </el-drawer>

        <!-- 占位元素 -->
        <div v-if="shouldAlwaysWhite" class="h-[13.33vw] w-full"></div>
    </div>
</template>

<script>
export default {
    name: 'mobile_HeaderBar',
    props: {
        shouldAlwaysWhite: {
            type: Boolean,
            default: true
        },
        shouldAlwaysFix: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isScrolled: false,
            drawer: false,
            direction: 'rtl',
            menuItems: [
                { label: '首页', path: '/' },
                { label: '关于我们', path: '/AboutUs' },
                { label: '课程体系', path: '/CourseSystem' },
                { label: '白名单赛事', path: '/Competition' },
                { label: '全国加盟', path: '/JoinUs' },
                { label: '新闻中心', path: '/News' },
                { label: '联系我们', path: '/ContactUs' }
            ]
        }
    },
    methods: {
        // 处理滚动事件
        handleScroll() {
            this.isScrolled = window.scrollY > 0
        },
        // 处理菜单点击
        handleMenuItemClick(path) {
            this.drawer = false
            if (this.$route.path === path) {
                this.$router.go(0)
            } else {
                this.$router.push(path).catch(() => {
                    this.$router.push('/404')
                })
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style scoped>
.menu-line {
    width: 100%;
    height: 0;
    background-color: currentColor;
    outline: 0.2vw solid #000000;
    outline-offset: -0.1vw;
    transition: transform 0.3s ease;
}

/* 抽屉样式保持不变 */
::v-deep .el-drawer__header {
    width: 100%;
    height: 13.33vw;
    color: #000000;
    padding: 3.47vw;
    margin: 0;
}

::v-deep .el-drawer__close-btn {
    font-size: 6vw;
    color: #000000;
}

::v-deep .el-drawer__body {
    width: 100%;
    padding: 0 3.47vw;
}

::v-deep .el-menu {
    margin-right: 0 !important;
    padding-right: 0 !important;
    border-right: none !important;
}

::v-deep .el-menu-item {
    height: 14vw;
    font-size: 4.26vw;
    font-family: "HarmonyOS Sans SC";
    color: #1a2233;
    font-weight: normal;
    border-top: 0.1vw solid #f0f0f0;
    border-bottom: 0.1vw solid #f0f0f0;
    padding: 0 4.26vw;
}

::v-deep .el-menu-item:active,
::v-deep .el-menu-item.active-item {
    background-color: #f5f5f5 !important;
    color: #999999 !important;
}
</style>
